module.exports = global["regeneratorRuntime"] = require("-!./runtime-module.js");


//////////////////
// WEBPACK FOOTER
// ./~/regenerator-runtime/runtime-module.js
// module id = 48
// module chunks = 0